import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { iBanCountry } from 'enums/regExp';
import { EDelkyZemi } from 'enums/validations/ibanValidationEnums';

const modulo97 = (value: string) => {
    let vysl: string | number = value.slice(0, 2);
    let cast;
    for (let offset = 2; offset < value.length; offset += 7) {
        cast = vysl + value.substring(offset, offset + 7);
        vysl = parseInt(cast) % 97;
    }

    return vysl;
};

/*
 * Vrat 1 pokud je IBAN validni
 * Vraci false pokud delka IBANu neodpovida (dle jednotlivych zemi)
 * Vraci cislo ruzne od 1 (checksum) pokud IBAN neni validni
 */

const validateIBAN = (input: string) => {
    // zeme a jejich delky dle https://www.iban.com/structure.html

    const iban = input.toUpperCase().replace(/[^A-Z0-9]/g, ''); // string obsahuje pouze alfanumericke znaky
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const kod: any = iban.match(iBanCountry);

    // zkontroluj syntaxi a delku
    if (!kod || iban.length !== parseInt(EDelkyZemi[kod[1]])) return false;
    // prehazej kod, zkontroluj cisla, preved na cislo
    const cisla = (kod[3] + kod[1] + kod[2]).replace(/[A-Z]/g, (chr: string) => {
        return String(chr.charCodeAt(0) - 55);
    });
    // finalni kontrola
    return modulo97(cisla);
};

export const ibanValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (!value || validateIBAN(value) === 1) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_IBAN</TranslateText>);
        }
    })
];

export default ibanValidation;
